/**
 * Every student- and instructor-facing string in the review surface.
 *
 * The wording is deliberately neutral: ConText is not an AI detector and makes
 * no authorship or misconduct claim, so these strings are treated as domain
 * data rather than presentation copy.
 */

export const FLAG_MESSAGES = {
  pasteDetected:
    "Text or an image was pasted into the writing area. If the content came from an external source, always remember to cite or acknowledge the source when appropriate.",
  shortWritingTime:
    "Short writing time. This prompt was completed in a short amount of time. Please make sure that you review your work for errors in grammar and punctuation, and make sure that your responses answer the question prompts thoroughly.",
  keystrokeMismatch:
    "Based on your activity, your keystrokes and character count do not align. This may indicate that you used an external editor to complete your assignment. If so, please notify your instructor to make them aware that your submission was not entirely written using this tool.",
  multiplePastes:
    "You've pasted content into the writing area several times. Consider keeping track of where the information came from and reviewing how it fits into your own writing.",
  highPasteRatio:
    "A large portion of this submission was added through pasted text. Take a moment to review how pasted material fits into your writing process and whether any sources or borrowed language need to be acknowledged.",
  // The "10" here counts actual leaves (blurEvents) and must stay in sync
  // with LEAVES_FLAG_THRESHOLD in constants.ts.
  focusChanges:
    "You've left the writing area 10 times. If you're researching, reviewing sources, or organizing ideas, that may be part of your process. When you're ready, return to your writing.",
} as const;

export const STEADY_MESSAGE =
  "Text developed steadily and consistently this session. No major flags were detected throughout this session.";

export const INSTRUCTOR_REVIEW_NOTICE =
  "Your instructor may review how this draft was developed. This may include copied-and-pasted text, writing time, typed writing, and revision activity.";

export const INSTRUCTOR_NO_FLAGS =
  "Writing is developing steadily with no major flags at this time.";

export const INSTRUCTOR_CONTEXT_NOTICE =
  "Instructor review notice: review these writing activity notes with assignment context in mind.";

export const STUDENT_NO_FLAGS =
  "Your writing looks steady so far. No major review notes are active right now.";

export const STUDENT_CONTEXT_NOTICE =
  "Instructor review notice: your instructor will also receive these writing activity notes.";
